<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='400px' center
             :before-close="dialogClose" :close-on-click-modal="false">
    <el-form :model="priceForm" :label-width="formLabelWidth" :rules="rules" style="margin: 0 auto">
      <el-form-item label="价格" prop="price">
        <el-input size="mini" type="number" v-model.number="priceForm.price"></el-input>
      </el-form-item>
      <el-form-item label="税率" prop="taxRate">
        <el-input size="mini" type="number" v-model.number="priceForm.taxRate"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size='mini' @click="dialogClose">取 消</el-button>
      <el-button size='mini' type="primary" @click="submit" :loading="submitLoading">确 定
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import {updatePrice} from "@/service/financial";

export default {
  data() {
    return {
      dialogTitle: '修改金额',
      dialogVisible: false,
      submitLoading: false,
      formLabelWidth: '60px',
      defaultPriceForm: {},
      priceForm: {
        id: '',
        price: '',
        taxRate: '',
        type: ''
      },
      rules: {
        price: [
          {
            required: true,
            message: '请输入价格',
            trigger: 'blur',
          },
        ],
        taxRate: [
          {
            required: true,
            message: '请输入税率',
            trigger: 'blur',
          },
        ],
      }
    }
  },
  mounted() {
    this.defaultPriceForm = JSON.parse(JSON.stringify(this.priceForm))
  },
  methods: {
    dialogOpen(id, type) {
      this.priceForm.id = id
      this.priceForm.type = type
      //让对话框显示
      this.dialogVisible = true
    },
    //点击确定
    async submit() {
      this.submitLoading = true;
      const {
        status,
        message,
      } = await updatePrice(this.priceForm);
      this.submitLoading = false;
      if (status !== 0) return this.$message.warning(message);
      this.$message.success(message);
      //触发父组件中定义的子组件上的方法，来调用父组件的具体方法
      this.$emit('success')
      this.dialogClose()
    },
    //关闭弹窗
    dialogClose() {
      this.dialogVisible = false
      this.priceForm = JSON.parse(JSON.stringify(this.defaultPriceForm))
    },
  }
}
</script>


<style scoped lang="scss">

</style>
